import React from 'react'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'

export const SpendAmount = {
  DontKnow: 'dontKnow',
  Below1000: 'below1000',
  Between1000And5000: 'between1000And5000',
  Over5000: 'over5000',
}

export default class StepSpend extends React.Component {
  render() {
    return (
      <>
        <p className={styles.question}>
          How much is your average <b>monthly</b> bill?
        </p>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.spend === SpendAmount.DontKnow}
            className={styles.formCheckInput}
            id={SpendAmount.DontKnow}
            name="spend"
            value={SpendAmount.DontKnow}
            onChange={this.props.handleChange}
          />
          <label htmlFor={SpendAmount.DontKnow}>Don&apos;t Know</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.spend === SpendAmount.Below1000}
            className={styles.formCheckInput}
            id={SpendAmount.Below1000}
            name="spend"
            value={SpendAmount.Below1000}
            onChange={this.props.handleChange}
          />
          <label htmlFor={SpendAmount.Below1000}>Below £1,000</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.spend === SpendAmount.Between1000And5000}
            className={styles.formCheckInput}
            id={SpendAmount.Between1000And5000}
            name="spend"
            value={SpendAmount.Between1000And5000}
            onChange={this.props.handleChange}
          />
          <label htmlFor={SpendAmount.Between1000And5000}>£1,000 - £5,000</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.spend === SpendAmount.Over5000}
            className={styles.formCheckInput}
            id={SpendAmount.Over5000}
            name="spend"
            value={SpendAmount.Over5000}
            onChange={this.props.handleChange}
          />
          <label htmlFor={SpendAmount.Over5000}>Over £5,000</label>
        </div>
      </>
    )
  }
}

StepSpend.propTypes = {
  spend: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}
